// src/components/Footer.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';
import { theme } from '../utils/constants';

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer
      style={{
        background: '#fff',
        color: '#111',
        padding: '5rem 24px 2rem',
        marginTop: 'auto',
        borderTop: '1px solid #dcdcdc'
      }}
    >
      <div
        style={{
          maxWidth: '1280px',
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
          gap: '3rem'
        }}
      >
        {/* Brand */}
        <div>
          <h3
            style={{
              fontSize: '1.7rem',
              marginBottom: '1rem',
              fontFamily: "'Roboto Slab', serif",
              fontWeight: 700,
              color: theme.primary
            }}
          >
            UPENDO STORE
          </h3>

          <p
            style={{
              color: '#2d2d2d',
              lineHeight: 1.8,
              fontSize: '0.96rem',
              fontWeight: 400
            }}
          >
            Buy authentic African products online. Upendo Store is a trusted
            marketplace offering Zambian coffee, e-bikes, fashion, books, car
            paint, ice supplies, and farm produce. Based in Lusaka, Zambia, we
            connect customers with premium, ethically sourced African products.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3
            style={{
              fontSize: '1.25rem',
              marginBottom: '1.3rem',
              fontWeight: 700,
              color: '#111'
            }}
          >
            Quick Links
          </h3>

          {['Shop', 'all products', 'accessories', 'Returns'].map((page) => (
            <div key={page} style={{ marginBottom: '0.85rem' }}>
              <button
                onClick={() => navigate(page)}
                style={{
                  color: '#111',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: 0,
                  font: 'inherit',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = theme.primary;
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = '#111';
                }}
              >
                {page.charAt(0).toUpperCase() + page.slice(1)}
              </button>
            </div>
          ))}
        </div>

        {/* Contact */}
        <div>
          <h3
            style={{
              fontSize: '1.25rem',
              marginBottom: '1.3rem',
              fontWeight: 700,
              color: '#111'
            }}
          >
            Contact
          </h3>

          <p style={{ marginBottom: '0.8rem', color: '#222' }}>
            📍 Lusaka, Zambia
          </p>

          <p style={{ marginBottom: '0.8rem', color: '#222' }}>
            ✉️ goldrichqueries@gmail.com
          </p>

          <p style={{ marginBottom: '1rem', color: '#222' }}>
            📞 +260 57 330 5986
          </p>
          

          <a
            href="https://wa.me/260573305986"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '10px',
              background: '#25D366',
              color: '#fff',
              padding: '12px 18px',
              borderRadius: '10px',
              textDecoration: 'none',
              fontWeight: 600,
              fontSize: '0.95rem',
              boxShadow: '0 4px 12px rgba(37, 211, 102, 0.25)',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#1EBE5D';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#25D366';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            <MessageCircle size={20} />
            Click here to chat with us on WhatsApp
          </a>
        </div>
      </div>

      <div
        style={{
          textAlign: 'center',
          marginTop: '3rem',
          paddingTop: '1.8rem',
          borderTop: '1px solid #dcdcdc',
          color: '#444',
          fontSize: '0.92rem',
          fontWeight: 500
        }}
      >
        © {new Date().getFullYear()} UPENDO STORE. All rights reserved.
      </div>
    </footer>
  );
}
// // src/components/Footer.jsx
// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import { theme } from '../utils/constants';

// export default function Footer() {
//   const navigate = useNavigate();

//   return (
//     <footer
//       style={{
//         background: '#fff',
//         color: '#111',
//         padding: '5rem 24px 2rem',
//         marginTop: 'auto',
//         borderTop: '1px solid #dcdcdc'
//       }}
//     >
//       <div
//         style={{
//           maxWidth: '1280px',
//           margin: '0 auto',
//           display: 'grid',
//           gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
//           gap: '3rem'
//         }}
//       >
//         {/* Brand */}
//         <div>
//           <h3
//             style={{
//               fontSize: '1.7rem',
//               marginBottom: '1rem',
//               fontFamily: "'Roboto Slab', serif",
//               fontWeight: 700,
//               color: theme.primary
//             }}
//           >
//             UPENDO STORE
//           </h3>

//           <p
//             style={{
//               color: '#2d2d2d',
//               lineHeight: 1.8,
//               fontSize: '0.96rem',
//               fontWeight: 400
//             }}
//           >
//             Buy authentic African products online. Upendo Store is a trusted
//             marketplace offering Zambian coffee, e-bikes, fashion, books, car
//             paint, ice supplies, and farm produce. Based in Lusaka, Zambia, we
//             connect customers with premium, ethically sourced African products.
//           </p>
//         </div>

//         {/* Quick Links */}
//         <div>
//           <h3
//             style={{
//               fontSize: '1.25rem',
//               marginBottom: '1.3rem',
//               fontWeight: 700,
//               color: '#111'
//             }}
//           >
//             Quick Links
//           </h3>

//           {['Shop', 'all products', 'accessories', 'Returns'].map((page) => (
//             <div key={page} style={{ marginBottom: '0.85rem' }}>
//               <button
//                 onClick={() => navigate(page)}
//                 style={{
//                   color: '#111',
//                   background: 'none',
//                   border: 'none',
//                   cursor: 'pointer',
//                   padding: 0,
//                   font: 'inherit',
//                   transition: 'color 0.2s ease'
//                 }}
//                 onMouseEnter={(e) => {
//                   e.target.style.color = theme.primary;
//                 }}
//                 onMouseLeave={(e) => {
//                   e.target.style.color = '#111';
//                 }}
//               >
//                 {page.charAt(0).toUpperCase() + page.slice(1)}
//               </button>
//             </div>
//           ))}
//         </div>

//         {/* Contact */}
//         {/* <div>
//           <h3
//             style={{
//               fontSize: '1.25rem',
//               marginBottom: '1.3rem',
//               fontWeight: 700,
//               color: '#111'
//             }}
//           >
//             Contact
//           </h3>

//           <p style={{ marginBottom: '0.8rem', color: '#222' }}>
//             📍 Lusaka, Zambia
//           </p>

//           <p style={{ marginBottom: '0.8rem', color: '#222' }}>
//             ✉️ goldrichqueries@gmail.com
//           </p>

//           <p style={{ marginBottom: '0.8rem', color: '#222' }}>
//             📞 +260 96 686 2222
//           </p>
//         </div> */}
//         {/* Contact */}
// <div>
//   <h3
//     style={{
//       fontSize: '1.25rem',
//       marginBottom: '1.3rem',
//       fontWeight: 700,
//       color: '#111'
//     }}
//   >
//     Contact
//   </h3>

//   <p style={{ marginBottom: '0.8rem', color: '#222' }}>
//     📍 Lusaka, Zambia
//   </p>

//   <p style={{ marginBottom: '0.8rem', color: '#222' }}>
//     ✉️ goldrichqueries@gmail.com
//   </p>

//   <p style={{ marginBottom: '0.8rem', color: '#222' }}>
//     📞 +260 96 686 2222
//   </p>

//   <a
//     href="https://wa.me/260966862222"
//     target="_blank"
//     rel="noopener noreferrer"
//     style={{
//       display: 'inline-flex',
//       alignItems: 'center',
//       gap: '8px',
//       color: '#25D366',
//       textDecoration: 'none',
//       fontWeight: 600,
//       transition: 'opacity 0.2s ease'
//     }}
//     onMouseEnter={(e) => {
//       e.currentTarget.style.opacity = '0.8';
//     }}
//     onMouseLeave={(e) => {
//       e.currentTarget.style.opacity = '1';
//     }}
//   >
//     💬 Chat with us on WhatsApp
//   </a>
// </div>
//       </div>

//       <div
//         style={{
//           textAlign: 'center',
//           marginTop: '3rem',
//           paddingTop: '1.8rem',
//           borderTop: '1px solid #dcdcdc',
//           color: '#444',
//           fontSize: '0.92rem',
//           fontWeight: 500
//         }}
//       >
//         © {new Date().getFullYear()} UPENDO STORE. All rights reserved.
//       </div>
//     </footer>
//   );
// }
// // src/components/Footer.jsx
// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import { theme } from '../utils/constants';

// export default function Footer() {
//   const navigate = useNavigate();

//   return (
//     <footer
//       style={{
//         background: '#fff',
//         color: '#111',
//         padding: '5rem 24px 2rem',
//         marginTop: 'auto',
//         borderTop: '1px solid #e5e5e5'
//       }}
//     >
//       <div
//         style={{
//           maxWidth: '1280px',
//           margin: '0 auto',
//           display: 'grid',
//           gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
//           gap: '3rem'
//         }}
//       >
//         {/* Brand */}
//         <div>
//           <h3
//             style={{
//               fontSize: '1.7rem',
//               marginBottom: '1rem',
//               fontFamily: "'Roboto Slab', serif",
//               color: theme.primary
//             }}
//           >
//             UPENDO STORE
//           </h3>

//           <p
//             style={{
//               color: '#555',
//               lineHeight: 1.8,
//               fontSize: '0.96rem'
//             }}
//           >
//             Buy authentic African products online. Upendo Store is a trusted
//             marketplace offering Zambian coffee, e-bikes, fashion, books, car
//             paint, ice supplies, and farm produce. Based in Lusaka, Zambia, we
//             connect customers with premium, ethically sourced African products.
//           </p>
//         </div>

//         {/* Quick Links */}
//         <div>
//           <h3
//             style={{
//               fontSize: '1.25rem',
//               marginBottom: '1.3rem'
//             }}
//           >
//             Quick Links
//           </h3>

//           {['Shop', 'all products', 'accessories', 'Returns'].map((page) => (
//             <div key={page} style={{ marginBottom: '0.8rem' }}>
//               <button
//                 onClick={() => navigate(page)}
//                 style={{
//                   color: '#333',
//                   background: 'none',
//                   border: 'none',
//                   cursor: 'pointer',
//                   padding: 0,
//                   font: 'inherit',
//                   transition: 'color .2s ease'
//                 }}
//                 onMouseEnter={(e) => {
//                   e.target.style.color = theme.primary;
//                 }}
//                 onMouseLeave={(e) => {
//                   e.target.style.color = '#333';
//                 }}
//               >
//                 {page.charAt(0).toUpperCase() + page.slice(1)}
//               </button>
//             </div>
//           ))}
//         </div>

//         {/* Contact */}
//         <div>
//           <h3
//             style={{
//               fontSize: '1.25rem',
//               marginBottom: '1.3rem'
//             }}
//           >
//             Contact
//           </h3>

//           <p style={{ marginBottom: '0.8rem', color: '#555' }}>
//             📍 Lusaka, Zambia
//           </p>

//           <p style={{ marginBottom: '0.8rem', color: '#555' }}>
//             ✉️ mapcan55@gmail.com
//           </p>

//           <p style={{ marginBottom: '0.8rem', color: '#555' }}>
//             📞 +260 97 123 4567
//           </p>
//         </div>
//       </div>

//       <div
//         style={{
//           textAlign: 'center',
//           marginTop: '3rem',
//           paddingTop: '1.8rem',
//           borderTop: '1px solid #e5e5e5',
//           color: '#666',
//           fontSize: '0.9rem'
//         }}
//       >
//         © {new Date().getFullYear()} UPENDO STORE. All rights reserved.
//       </div>
//     </footer>
//   );
// }
// // src/components/Footer.jsx
// import React from 'react';

// import { theme } from '../utils/constants';

// //import navigate to react-router-dom or any other navigation library if needed
// import { useNavigate } from 'react-router-dom';


// export default function Footer() {
// //export default function Footer({ navigateTo }) {
//   const navigate = useNavigate();

//   return (
//     <footer
//       style={{
//         background: `linear-gradient(135deg, ${theme.primaryDark}, ${theme.primary})`,
//         color: 'white',
//         padding: '5rem 24px 3rem',
//         marginTop: 'auto'
//       }}
//     >
//       <div
//         style={{
//           maxWidth: '1280px',
//           margin: '0 auto',
//           display: 'grid',
//           gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
//           gap: '3rem'
//         }}
//       >
//         {/* Brand & Description */}
//         <div>
//           <h3
//             style={{
//               fontSize: '1.6rem',
//               marginBottom: '1.5rem',
//               fontFamily: "'Roboto Slab', serif"
//             }}
//           >
//             UPENDO STORE
//           </h3>
//           <p style={{ opacity: 0.9, lineHeight: 1.7, fontSize: '0.97rem' }}>
//             Buy authentic african products online. upendo store is a trusted market place offering zambian coffee, ebikes, fashion,books, car paint and ice supplies, and farm produce Based in Lusaka,Zambia. Your trusted marketplace for premium, ethically made products fro our beloved africa
//           </p>
//         </div>

//         {/* Quick Links */}
//         <div>
//           <h3 style={{ fontSize: '1.3rem', marginBottom: '1.5rem' }}>Quick Links</h3>
//           {['Shop', 'all products', 'accessories', 'Returns'].map(page => (
//             <div key={page} style={{ marginBottom: '0.9rem' }}>
//               <button
//                 onClick={() => navigate(page)}
//                 style={{
//                   color: 'white',
//                   background: 'none',
//                   border: 'none',
//                   cursor: 'pointer',
//                   padding: 0,
//                   font: 'inherit'
//                 }}
//               >
//                 {page.charAt(0).toUpperCase() + page.slice(1)}
//               </button>
//             </div>
//           ))}
//         </div>

//         {/* Contact */}
//         <div>
//           <h3 style={{ fontSize: '1.3rem', marginBottom: '1.5rem' }}>Contact</h3>
//           <p style={{ marginBottom: '0.8rem' }}>📍 Lusaka, Zambia</p>
//           <p style={{ marginBottom: '0.8rem' }}>✉️ mapcan55@gmail.com </p>
//         </div>
//       </div>

//       <div
//         style={{
//           textAlign: 'center',
//           marginTop: '4rem',
//           paddingTop: '2rem',
//           borderTop: '1px solid rgba(255,255,255,0.15)',
//           opacity: 0.8,
//           fontSize: '0.95rem'
//         }}
//       >
//         © {new Date().getFullYear()} UPENDO STORE. All rights reserved.
//       </div>
//     </footer>
//   );
// }